import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AdminCtx = createContext(null);

export function AdminProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = logged out
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("ascend_admin_token");
    if (!token) {
      setAdmin(false);
      setReady(true);
      return;
    }
    api
      .get("/admin/me")
      .then((r) => setAdmin(r.data))
      .catch(() => {
        localStorage.removeItem("ascend_admin_token");
        setAdmin(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/admin/login", { email, password });
    localStorage.setItem("ascend_admin_token", data.token);
    setAdmin(data.admin);
    return data.admin;
  };

  const logout = () => {
    localStorage.removeItem("ascend_admin_token");
    setAdmin(false);
  };

  return <AdminCtx.Provider value={{ admin, ready, login, logout }}>{children}</AdminCtx.Provider>;
}

export const useAdmin = () => useContext(AdminCtx);
